/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserDto } from '../models/CreateUserDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static usersControllerCreate(requestBody: CreateUserDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all users with pagination and filters
   * @param page Page number (1-based)
   * @param limit Items per page
   * @param searchTerm Search by name or email
   * @param status Filter by status
   * @param startDate Start date filter (ISO string)
   * @param endDate End date filter (ISO string)
   * @param sortBy Sort field
   * @param roleIds Filter by role IDs
   * @returns any Users retrieved successfully
   * @throws ApiError
   */
  public static usersControllerFindAll(
    page?: number,
    limit?: number,
    searchTerm?: string,
    status?: 'all' | 'active' | 'inactive',
    startDate?: string,
    endDate?: string,
    sortBy?: string,
    roleIds?: Array<string>,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users',
      query: {
        page: page,
        limit: limit,
        searchTerm: searchTerm,
        status: status,
        startDate: startDate,
        endDate: endDate,
        sortBy: sortBy,
        roleIds: roleIds,
      },
    });
  }
  /**
   * Get current user permissions
   * @returns any Current user permissions retrieved successfully
   * @throws ApiError
   */
  public static usersControllerGetMyPermissions(): CancelablePromise<{
    permissions?: Array<string>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/me/permissions',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Get user permissions
   * @param id User ID
   * @returns any User permissions retrieved successfully
   * @throws ApiError
   */
  public static usersControllerGetUserPermissions(id: string): CancelablePromise<{
    permissions?: Array<string>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/permissions',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden - Admin only`,
        404: `User not found`,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static usersControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static usersControllerUpdate(
    id: string,
    requestBody: UpdateUserDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/users/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static usersControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Block a user
   * @param id User ID
   * @returns any User blocked successfully
   * @throws ApiError
   */
  public static usersControllerBlockUser(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/block',
      path: {
        id: id,
      },
      errors: {
        404: `User not found`,
      },
    });
  }
  /**
   * Unblock a user
   * @param id User ID
   * @returns any User unblocked successfully
   * @throws ApiError
   */
  public static usersControllerUnblockUser(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/unblock',
      path: {
        id: id,
      },
      errors: {
        404: `User not found`,
      },
    });
  }
  /**
   * Reset user password to a temporary value
   * @param id User ID
   * @returns any Password reset, returns temporary password
   * @throws ApiError
   */
  public static usersControllerResetPassword(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/reset-password',
      path: {
        id: id,
      },
      errors: {
        400: `Cannot reset own password`,
        404: `User not found`,
      },
    });
  }
  /**
   * Export users to CSV
   * @returns any CSV file generated successfully
   * @throws ApiError
   */
  public static usersControllerExportUsers(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/export/csv',
    });
  }
}
